// MHM-3.5 — Global drawer context. Any nested component can call
// useOrderDrawer().open(tid) to pop the unified OrderDetailDrawer
// without prop-drilling. The provider is mounted once in App.js.
// MHM-6.D — Auto-open from `?open=<tid>` so deep-link / Playwright can
// open the drawer without navigating through a list page first.
import { createContext, useContext, useState, useCallback, useEffect } from "react";

const OrderDrawerCtx = createContext({ open: () => {}, openOrder: () => {}, close: () => {} });

export function OrderDrawerProvider({ children }) {
  const [tid, setTid] = useState(null);
  const open = useCallback((trackingId) => setTid(trackingId), []);
  const close = useCallback(() => setTid(null), []);
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const t = url.searchParams.get("open");
      if (t) setTid(t);
    } catch (e) { /* ignore */ }
  }, []);
  return (
    <OrderDrawerCtx.Provider value={{ open, openOrder: open, close, tid, isOpen: !!tid }}>
      {children}
    </OrderDrawerCtx.Provider>
  );
}

export function useOrderDrawer() {
  return useContext(OrderDrawerCtx);
}
